import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getHalIncotermsListAPI = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/inco-terms`,
    method: 'get',
  });
};

export type HalIncotermsListResponse = {
  codeId: string; // 'CAD'
}[];

export const fetchHalIncotermsList = async (): Promise<HalIncotermsListResponse> => {
  const response: AxiosResponse<HalIncotermsListResponse> = await getHalIncotermsListAPI();
  return response.data;
};
